import { SelectContent, SelectItem } from '@components/ui/select'

import { z } from 'zod'

const industryOptions: readonly [string, ...string[]] = [
  'Agriculture',
  'Banking & Finance',
  'Construction & Engineering',
  'Education',
  'Federal Government',
  'Healthcare',
  'Insurance',
  'Local Government',
  'Manufacturing',
  'Media & Entertainment',
  'Mining',
  'Not For Profit',
  'Professional Services',
  'Retail',
  'State Government',
  'Technology',
  'Telecommunications',
  'Transportation',
  'Utilities',
  'Other',
]

export const SelectIndustryContent = () => (
  <SelectContent>
    {industryOptions.map((industry, index) => (
      <SelectItem key={index} value={industry}>
        {industry}
      </SelectItem>
    ))}
  </SelectContent>
)

export const zodIndustryOptions = z.enum(industryOptions, {
  message: 'Please select an industry',
})
